// @flow
/* eslint-disable */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import { H4 } from 'components';
import cards from '../../../assets/images/CardComp.png'
import cardsBlue from '../../../assets/images/CardCompBlue.png'
import cardsGreen from '../../../assets/images/CardCompGreen.png'
import cardsPlo5 from '../../../assets/images/CardCompPLO5.png'
import cardsPlo5Blue from '../../../assets/images/CardCompPLO5Blue.png'
import cardsPlo5Green from '../../../assets/images/CardCompPLO5Green.png'

type Props = {
  label: string,
  circleValue: number,
  index: number,
  className?: string,
  show: boolean,
  isPositionActive: boolean,
  stackSize: number,
  bet?: number,
  startingBet?: number,
  chipsCollected?: boolean,
  setCurrentActivePos: () => void,
  cardColor?: string,
  handleCardClick?: () => void,
  isPlo5?: boolean,
  hideCards?: boolean,
  hu?: boolean,
};

const PositionCircle = ({
  label,
  circleValue,
  index,
  className,
  show,
  isPositionActive,
  stackSize,
  bet,
  startingBet,
  chipsCollected = false,
  setCurrentActivePos,
  cardColor,
  handleCardClick,
  isPlo5,
  hideCards = false,
  hu = false,
}: Props) => {
  const displayLabel = label.replace(/\bBTN\b/g, 'BU');
  const dealerLabel = displayLabel.toLowerCase();
  const showDealerChip = dealerLabel.includes('bu') || (hu && dealerLabel.includes('sb'));

  useEffect(() => {
    if (isPositionActive) {
      setCurrentActivePos(label)
    }
  }, [isPositionActive])

  if (!show) {
    return ''
  }

  const handleCardColorShow = () => {
    if (isPlo5) {
      switch (cardColor) {
        case 'red': {
          return cardsPlo5
        }
        case 'blue': {
          return cardsPlo5Blue
        }
        case 'green': {
          return cardsPlo5Green
        }
        default: {
          return cardsPlo5
        }
      }
    } else {
      switch (cardColor) {
        case 'red': {
          return cards
        }
        case 'blue': {
          return cardsBlue
        }
        case 'green': {
          return cardsGreen
        }
        case '' : {
          return cards
        }
        default: {
          return cards
        }
      }
    }
  }

  const positionDealerChip = classnames(
    styles.dealerChip,
    {  [styles.positionDealerChip0]: index === 0 },
    {  [styles.positionDealerChip1]: index === 1 },
    {  [styles.positionDealerChip2]: index === 2 },
    {  [styles.positionDealerChip3]: index === 3 },
    {  [styles.positionDealerChip4]: index === 4 },
    {  [styles.positionDealerChip5]: index === 5 },
  )

  const positionBet = classnames(
    {  [styles.positionBet0]: index === 0 },
    {  [styles.positionBet1]: index === 1 },
    {  [styles.positionBet2]: index === 2 },
    {  [styles.positionBet3]: index === 3 },
    {  [styles.positionBet4]: index === 4 },
    {  [styles.positionBet5]: index === 5 },
  )

  const showBet = () => {
    if (chipsCollected) return ''
    const visibleBet = Number(bet) > 0 ? bet : startingBet
    if (visibleBet === '' || visibleBet === null || visibleBet === undefined) return ''
    if (Number(visibleBet) === 0) return ''
    return Number(visibleBet).toFixed(1)
  }

  const normalizedBet = Number(bet) || 0
  const remainingStack = Math.max(0, circleValue - normalizedBet)

  return (
    <div
      className={
        classnames(
          styles.positionCircleContainer,
          {[styles.opponent]: !isPositionActive},
          {[styles.active]: isPositionActive},
          {[styles.huPositionCircle]: hu},
          className
        )
      }
    >
      <div className={styles.wrap}>
        {showDealerChip && <div className={positionDealerChip}>D</div>}
        <div className={classnames(styles.co, positionBet)}>{showBet()}</div>
        <div className={styles.innerWrap}>
          <div className={styles.betOption}>
            <H4 className={styles.bet} color={"white"}>{remainingStack.toFixed(1)}</H4>
            <H4 className={styles.position}>{displayLabel.toUpperCase()}</H4>
          </div>
        </div>
      </div>
      {!hideCards && (
        <button
          type="button"
          aria-label={`Change ${displayLabel.toUpperCase()} card back color`}
          title="Change card back color"
          onClick={handleCardClick}
          className={classnames(styles.cardBackButton, {
            [styles.cardBackButtonPlo5]: isPlo5,
          })}
        >
          <img src={handleCardColorShow()} alt="" draggable={false} />
        </button>
      )}
    </div>
  );
};

export default PositionCircle;
